export default function getResource(label, vars = []) {
    const resources = {
        selectedProduct: `Selected Product ${vars[0]}`,
        emptySlot: 'Empty Slot',
        compareProducts: 'Compare Products',
        of: 'of',
        minimize: 'Minimize',
        maximize: 'Maximize',
        clearAll: 'Clear All',
        compare: 'Compare',
        removeProduct: 'Remove Product'
    };

    return resources[label];
}
